module.exports = __webpack_public_path__ + "static/media/Bank Muamalat.85f4fcad.svg";